import { takeEvery, put } from 'redux-saga/effects';
import { actions } from 'components/StockFilters/actions';
import { LocationChangeAction } from 'connected-react-router';

export function* routeChange() {
  yield takeEvery('@@router/LOCATION_CHANGE', function* logger(v: LocationChangeAction) {
    const {
      payload: {
        location: { pathname },
      },
    } = v;

    const isPathToStock = pathname.split('/').includes('stocks');

    if (!isPathToStock) {
      yield put(actions.reset());
    }
  });
}
